import React, { VFC } from 'react'

export const NotFoundUi: VFC = () => {
  return <h1 className="text-xl">محتوى غير موجود</h1>
}
